<template>
  <div class="import-jobs">
    <div  @click="openDialog()">
    <slot>
    <el-button
      size="small"
      style="width: 100%; margin-top: 28px; margin-bottom: 8px"
    >
      Привязка работ <strong>{{name}}</strong>
    </el-button>
    </slot>
    </div>

    <el-dialog :title="`Привязка работ - ${$store.state.project.plan && $store.state.project.plan.name || 'Директивный план'}`" :visible.sync="dialogObject">
      <div class="add-jobs" v-show="!objectId" v-if="dialogObject">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <el-table
          row-key="id"
          @select="handleSelectionChangeObject"
          @select-all="handleSelectionChangeObject"
          empty-text="Объекты не найдены"
          ref="multipleObjectTable"
          :data="filteredList"
          style="width: 100%"
        >
          <el-table-column
            property="check"
            type="selection"
            width="55"
          >
          </el-table-column>
          <el-table-column
            property="name"
            label="Объекты"
          >
          </el-table-column>
          <el-table-column
            width="50px"
          >
            <template slot-scope="scope">
              <i class="fa fa-edit" @click="selectObject(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
        <!--        <div class="jobs-ul">-->
        <!--          <div-->
        <!--            @click="selectObject(list)"-->
        <!--            class="jobs-li" v-for="(list, index) in filteredList" :key="index"-->
        <!--          >-->
        <!--            <span>{{ list.name }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="add-jobs" v-show="objectId" v-loading="loading">
        <el-input placeholder="Поиск ..." v-model="jobSearch" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <div class="jobs-ul">

          <el-table
            @selection-change="handleSelectionChangeJob"
            empty-text="Работы не найдены"
            ref="jobsTable"
            :data="filteredJobs"
            style="width: 100%"
          >
            <el-table-column
              property="check"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              property="name"
              label="Работы"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="create-footer">
        <el-button @click="back" v-if="objectId">Назад</el-button>
        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import _ from 'lodash';
import {getChildList} from '../../../../utils/getChild';

export default {
  name: 'PermissionObjectVersion',
  props: ['name', 'version', 'id', 'planId'],
  data() {
    return {
      search: '',
      jobSearch: '',
      dialogObject: false,
      objectId: null,
      selectedObjects: [],
      selectedJob: [],
      loading: false,
      availableJobs: {},
      availableObjects: [],
      list: [],
      jobs: [],
    };
  },
  computed: {
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredJobs() {
      return this.jobs.filter(object => {
        return object.name.toLowerCase().includes(this.jobSearch.toLowerCase());
      });
    },
  },

  watch: {
    filteredList: _.debounce(function () {
      let version = this.version || {}

      this.filteredList.map((row) => {
        const availableObjects = this.availableObjects.map((a) => a.id);
        if (availableObjects.includes(row.id) || (version.available_objects && version.available_objects.includes(row.id))) {
          this.$refs.multipleObjectTable.toggleRowSelection(row);
        }
      })
    }, 200),
    filteredJobs: _.debounce(function () {
      let version = this.version || {}

      this.filteredJobs.map((row) => {

        const availableJobs1 = this.availableJobs[this.objectId].map((a) => a.id);

        if (availableJobs1.includes(row.id)
          || (version.available_jobs && version.available_jobs[this.objectId]
            && version.available_jobs[this.objectId].includes(row.id))
        ) {
          this.$refs.jobsTable.toggleRowSelection(row);
        }
      })
    }, 200)
  },

  mounted() {
    this.fetchTree();
  },

  methods: {
    fire() {
      if(this.planId) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.planId)
      }

        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
    },
    selectObject({id}) {
      this.objectId = id;
      this.fetchJobs();
    },
    back() {
      this.objectId = null;
    },
    openDialog() {
      let version = this.version || {}

      this.dialogObject = true;
      setTimeout(() => {
        this.list.map((row) => {
          if (version.available_objects && version.available_objects.includes(row.id)) {
            this.$refs.multipleObjectTable.toggleRowSelection(row);
            this.availableObjects.push(row);
          }
        })
      }, 100);
    },
    fetchJobs() {
      let version = this.version || {}

      this.fire()
        .collection('jobs')
        .where('type', '==', 'JOB')
        .where(`objects`, 'array-contains-any', [this.objectId]).get()
        .then((data) => {
          const result = [];
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              _data: data,
              index: data.index
            });
          });

          this.jobs = _.orderBy(result, 'index', ['asc']);
          const available_jobs =  version.available_jobs[this.objectId]  || {};

          setTimeout(() => {
            this.availableJobs[this.objectId] = [];
            this.jobs.map((row) => {
              if (version.available_jobs && available_jobs.includes(row.id)) {
                this.availableJobs[this.objectId].push(row)
              }
            })
          }, 100);
        });
    },
    handleSelectionChangeObject(selected) {
      this.selectedObjects = selected;
      this.availableObjects = this.list.filter((s) => {
        return this.selectedObjects.find((l) => l.id === s.id)
      });
    },
    handleSelectionChangeJob(selected) {
      this.selectedJob = selected;

      const available = [];
      if (Array.isArray(this.availableJobs)) {
        this.availableJobs = {};
      }

      this.availableJobs[this.objectId].map((d) => {
        if (this.selectedJob.find((s) => d.id === s.id)) {
          available.push(d);
        }
      })

      this.availableJobs[this.objectId] = [...available, ...this.jobs.filter((s) => {
        return this.selectedJob.find((l) => l.id === s.id);
      })];
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
          if(!this.planId) {
            this.list = [
              {
                id: 'all',
                name: 'Корневой каталог',
                index: 0,
                isParent: true,
              },
              ..._.orderBy(getChildList(result), 'index', ['asc']),
            ];
          } else {
            this.list = [
              {
                id: 'all',
                name: 'Корневой каталог',
                index: 0,
                isParent: true,
              },
              ..._.orderBy(getChildList(result), 'index', ['asc']),
            ];
          }
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    async save() {
      this.loading = true;
      const availableJobs = {}
      const versions_jobs = this.version && this.version.available_jobs || {};

      Object.entries(this.availableJobs).forEach(([key, value]) => {
        availableJobs[key] = _.uniq(value.map((o) => o.id))
      })
      //
      // batch.commit().then((response) => {
      // this.loading = false;
      // this.$notify({
      //   offset: 60,
      //   title: 'Успешно!',
      //   message: 'Доступы изменены',
      //   type: 'success',
      // });
      this.$emit('update', {
        ...this.version,
        available_jobs: {...versions_jobs, ...availableJobs},
        available_objects: _.uniq(this.availableObjects.map((o) => o.id))
      });
      if (this.objectId) {
        return this.objectId = null;
      } else {
        this.close();
      }
      // });
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.objectId = null;
      this.selectedJob = [];
      this.selectedObjects = [];
      this.search = '';
    },
  },
};
</script>

<style scoped lang="scss">

.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

.create-footer {
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
}

.jobs-core {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 15px 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/components/PermissionObjectVersion.vue